/**
 * Centralized types and enums for all drag-and-drop operations in the app.
 * Used by @dnd-kit and UI components to ensure type safety and consistent handling
 * of draggable items (lists, dividers, cards, events) in trip planning features.
 */
export enum ItemType {
  CARD = 'card',
  LIST = 'list',
  EVENT = 'event',
  DIVIDER = 'divider',
}
